import createSSCLocale from './create-ssc-locale';

const ne: Record<string, string> = require('./ne_NP.json');

export default createSSCLocale(ne);
